import React from 'react'
import './BusinessDiscount.scss'
import BusinessDiscountCard from './BusinessDiscountCard/BusinessDiscountCard'

const BusinessDiscount = ({data}) => {
  return (
    <div className='businessDiscount_container'>
      <div className="businessDiscount_block">
        <div className="businessDiscount_item">
            <h2>Популярные запросы</h2>
            <p>Всё самое полезное для бизнеса — в одном месте</p>
        </div>
        <div className="businessDiscount_collection">
           {
            data?.map((i)=>
            <BusinessDiscountCard key={i.id} img={i.img} title={i.title} link={i.link}/>
            )
           }
        </div>
      </div>
    </div>
  )
}

export default BusinessDiscount
